import { THEMES, type ThemeId } from "@smartvow/shared";

export function ThemeSelect({
  value,
  onChange,
}: {
  value: ThemeId;
  onChange: (id: ThemeId) => void;
}) {
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {THEMES.map((t) => {
        const active = t.id === value;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            className={`flex flex-col gap-2 rounded-xl border p-3 text-left transition ${
              active
                ? "border-stone-900 ring-1 ring-stone-900"
                : "border-stone-200 hover:border-stone-300"
            }`}
          >
            <span className="flex gap-1">
              {t.swatches.map((c) => (
                <span
                  key={c}
                  className="h-5 w-5 rounded-full border border-black/5"
                  style={{ background: c }}
                />
              ))}
            </span>
            <span className="text-xs font-medium text-stone-800">{t.name}</span>
            <span className="text-[11px] leading-tight text-stone-400">{t.description}</span>
          </button>
        );
      })}
    </div>
  );
}
